import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdArrowBack, MdAutoAwesome } from "react-icons/md";
import MainLogo from "../../assets/image/logo.png";

export default function NotFound() {
  const navigate = useNavigate();
  const { isAuthenticated, token } = useSelector((state) => state.auth);
  const isLoggedIn = Boolean(isAuthenticated || token);

  const handleGoHome = () => {
    navigate(isLoggedIn ? "/playground" : "/login");
  };

  return (
    <div className="min-h-screen w-full bg-[#E2E6ED] flex flex-col items-center justify-center p-4 antialiased">
      {/* Centered Clean Card */}
      <div className="bg-white rounded-xl shadow-md border border-slate-200 p-7 sm:p-9 max-w-[440px] w-full text-left">
        {/* Brand Logo Header & 404 Tag */}
        <div className="mb-5 flex items-center justify-between pb-4 border-b border-slate-100">
          <img src={MainLogo} alt="VTO Couture" className="h-7 w-auto object-contain" />
          <span className="text-xs font-bold text-amber-500 uppercase tracking-wider bg-amber-50 border border-amber-200 px-2 py-0.5 rounded">
            404
          </span>
        </div>

        {/* Title */}
        <h1 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
          Page Not Found
        </h1>

        {/* Explanation Section */}
        <div className="mt-4">
          <h2 className="text-xs sm:text-sm font-semibold text-slate-700">
            Why am I seeing this?
          </h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1 leading-relaxed">
            This error occurs because the application couldn’t find the specific page you were looking for. It may have been moved, renamed, or deleted.
          </p>
        </div>

        {/* Action Buttons (preserved as requested) */}
        <div className="mt-6 flex flex-col sm:flex-row items-center gap-2.5 pt-2">
          <button
            type="button"
            onClick={handleGoHome}
            className="w-full flex-1 flex items-center justify-center gap-2 bg-primary text-white hover:bg-slate-800 active:scale-[0.98] transition-all px-4 py-2.5 rounded-lg text-xs sm:text-sm font-semibold shadow-sm cursor-pointer border-none"
          >
            <MdAutoAwesome size={15} />
            <span>{isLoggedIn ? "Go to Playground" : "Go to Login"}</span>
          </button>

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto flex items-center justify-center gap-1.5 bg-white text-slate-700 hover:text-slate-900 hover:bg-slate-50 border border-slate-200 active:scale-[0.98] transition-all px-4 py-2.5 rounded-lg text-xs sm:text-sm font-semibold cursor-pointer"
          >
            <MdArrowBack size={15} />
            <span>Previous Page</span>
          </button>
        </div>
      </div>
    </div>
  );
}
